var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C11 6.2279 10.3833 5.6 9.625 5.6H8.9375V3.5C8.9375 1.5701 7.39544 0 5.5 0C3.60456 0 2.0625 1.5701 2.0625 3.5V5.6H1.375C0.616687 5.6 0 6.2279 0 7V12.6C0 13.3721 0.616687 14 1.375 14H9.625C10.3833 14 11 13.3721 11 12.6V7ZM3.4375 3.5C3.4375 2.3422 4.36287 1.4 5.5 1.4C6.63713 1.4 7.5625 2.3422 7.5625 3.5V5.6H3.4375V3.5Z",
    fill: "#B9B9B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock_icon.f5756a2521a39febd8dcc62d8df9d6d2.svg";
export { ForwardRef as ReactComponent };